import { KeyValueList, type KeyValueRow } from '@/components/key-value-list';
import { SecretRow } from '@/components/secret-row';
import { formatAgo, formatClock } from '@/shared/lib/format';
import type { ClaudeCodeConnectionData } from '@/shared/types/workspace';
import { maskEnvironmentKey } from '../model/claude-key';

function lastSessionText(connection: ClaudeCodeConnectionData): string {
  if (connection.status === 'KEY_REJECTED' && connection.rejectedAt) {
    return `Failed at ${formatClock(connection.rejectedAt)}, key rejected`;
  }
  return connection.lastSessionAt ? formatAgo(connection.lastSessionAt) : 'No sessions yet';
}

export function ClaudeCodeDetails({ connection }: { connection: ClaudeCodeConnectionData }) {
  const environment: KeyValueRow[] = connection.environmentName
    ? [
        {
          key: 'env',
          label: 'Environment',
          value: connection.environmentName,
          valueClassName: 'font-mono text-mono',
        },
      ]
    : [];
  const rows: KeyValueRow[] = [
    ...environment,
    {
      key: 'key',
      label: 'Environment key',
      value: <SecretRow value={maskEnvironmentKey(connection.keyHint)} />,
    },
    { key: 'last', label: 'Last session', value: lastSessionText(connection) },
  ];
  return <KeyValueList rows={rows} labelClassName="text-muted" />;
}
